import { useSlate } from 'slate-react';
import { isBlockActive, toggleBlock, isSimpleBlockActive } from 'slate/functions';
import { forwardRef } from 'react';
import { toggleList } from 'slate/extensions/list';

const LIST_TYPES = ['numbered-list', 'bulleted-list'];

type BlockStyling = { alignment?: string; indent?: boolean; format?: string | null; class?: string; [key: string]: unknown };

interface BlockButtonProps {
  format: string;
  icon: string;
  css?: string;
  styling?: BlockStyling;
  text?: string;
}

export const BlockButton = forwardRef<HTMLButtonElement, BlockButtonProps>(({ format, icon, css, styling }, ref) => {
  const editor = useSlate();
  return (
    <button
      ref={ref}
      className={`${css} ${
        isBlockActive(editor, format, styling) || ((format === 'numbered-list' || format === 'bulleted-list') && isSimpleBlockActive(editor, format))
          ? 'active'
          : ''
      }`}
      onMouseDown={(event) => {
        event.preventDefault();
        if (LIST_TYPES.includes(format)) {
          toggleList(editor, format);
          return;
        }
        toggleBlock(editor, format, styling);
      }}
    >
      <i className={`fa-regular fa-${icon}`} />
    </button>
  );
});
